module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/video.5a190815-4050284b7858125c56f36aac96b5048e.png";